<template>
  <div>
    <div class="grid grid-cols-[38%,1%,49%] gap-5">
      <div>
        <div class="text-left text-base font-bold">{{ $t('编辑收款信息') }}</div>
        <el-form label-position="left" label-width="auto" :model="formData" :rules="rules" ref="form">
          <el-form-item :label="$t('名称')" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('收款信息图片')" prop="img_url">
            <ir-images v-model="formData.img_url" imagesStyle="display:flex;justify-content:flex-start;"></ir-images>
          </el-form-item>
          <el-form-item :label="$t('收款信息文字')" prop="info">
            <el-input v-model="formData.info"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit('ruleForm')">{{ type }}</el-button>
            <el-button @click="reset('ruleForm')">{{ $t('重置') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <p class="h-full bg-mainGray "></p>
      <div class="space-y-3">
        <div class="text-left text-base font-bold">{{ $t('已有收款信息') }}</div>
        <div v-for="list in lists" :key="list.id" class="list">
          <div class="name">{{ list.name }}</div>
          <img :src="$smallImage(list.collecimage)">
          <div class="text-sm">{{ list.collecinfo }}</div>
          <div class="iconfont icon-bianji icon" @click="edit(list)"></div>
          <span style="color:#FF4747" @click="delCollectionInfo(list.id)">{{ $t('删除') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import irImages from "@/components/base/ir-images.vue";

import { computed, ref, reactive, onMounted } from "@vue/composition-api";
export default {
  components: { irImages },
  setup(props, ctx) {
    const lists = ref([])
    const user = computed(() => ctx.root.$store.getters.user)

    const loader = ref(new ctx.root.$Loader({
      apiname: 'sup/getCollectionInfo',
      size: -1,
      param: () => ({
        sid: user.value.supplier_id
      }),
      onLoaded: (res) => {
        if (res.code == 0 && res.data) {
          lists.value = res.data.items
        }
      }
    }))
    onMounted(async () => {
      await ctx.root.$loadUserInfo()
      await loader.value.load()

    })
    const formData = reactive({
      name: "",
      img_url: "",
      info: "",
      pid: "",
    })
    const rules = {
      name: { required: true, message: ctx.root.$t('请输入收款信息名称'), trigger: 'blur' },
      img_url: { required: true, message: ctx.root.$t('请选择收款信息图片'), trigger: 'change' },
      info: { required: true, message: ctx.root.$t('请输入收款信息提示'), trigger: 'blur' }

    }
    const type = ref(ctx.root.$t('立即创建'))
    const reset = () => {
      ctx.refs['form'].resetFields();
      type.value = ctx.root.$t('立即创建')
    }
    const submit = () => {
      ctx.refs['form'].validate(async (valid) => {
        if (valid) {
          let param = JSON.parse(JSON.stringify(formData))
          param.sid = user.value.supplier_id
          try {
            await ctx.root.$autoUploads(param, ['img_url'])
          } catch (e) {
            return ctx.root.$toast(ctx.root.$t('图片上传失败，请检查图片格式'))
          }

          let res = await ctx.root.$callapi('sup/setCollectionInfo', param)
          if (res.code == 0 && res.data) {
            ctx.root.$toast(ctx.root.$t('操作成功'), 'success')
            await loader.value.load()
            reset()
          }
        }
      })
    }

    const delCollectionInfo = async (list_id) => {
      let text = ctx.root.$t("你确定要删除该收款信息吗?")
      let query = await ctx.root.$query(text)
      if (!query) return
      let param = {"pid": list_id}
      let res = await ctx.root.$callapi('sup/deleteCollectionInfo', param)
      if (res.code == 0 && res.data) {
            ctx.root.$toast(ctx.root.$t('删除成功'), 'success')
            await loader.value.load()
            reset()
          }
    }

    const edit = (list) => {
      let r = JSON.parse(JSON.stringify(list))
      let { collecimage, collecinfo, name, id } = r
      formData.name = name
      formData.info = collecinfo
      formData.img_url = collecimage
      formData.pid = id
      type.value = ctx.root.$t('保存修改')

    }
    return { formData, rules, reset, submit, type, lists, edit, delCollectionInfo }
  }
}
</script>
<style scoped lang="scss">
.list {
  @apply grid grid-cols-[5rem,auto] border text-left p-2 gap-2 relative;
  img{
    width: 5rem;
    height: 5rem;
  }

  &:hover {
    @apply ring-main ring-1px;
  }

  .icon {
    @apply absolute right-2 top-2.5 text-gray-400;
  }

  .name {
    @apply col-start-1 col-end-3;
  }
}</style>